import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    addPeerConfiguration : [],
    loading : false,
    error : null,
};

const addPeerConfigurationSlice = createSlice({
    name:"addPeerConfiguration",
    initialState,
    reducers: {
        fetchaddPeerConfigurationSuccess: (state,action) => {
            state.loading = false;
            state.addPeerConfiguration = action.payload;
        },
        fetchaddPeerConfigurationFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchaddPeerConfigurationSuccess,
    fetchaddPeerConfigurationFailure
} = addPeerConfigurationSlice.actions

export default addPeerConfigurationSlice.reducer